import React, { useState } from 'react';
import axios from 'axios';

const Trucker = () => {
  const [ipAddress, setIpAddress] = useState('');
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLocation = async (ip) => {
    setLoading(true);
    setError(null);
    setLocation(null);

    try {
      const response = await axios.get(`https://ipinfo.io/${ip}?token=YOUR_IPINFO_API_KEY`);
      console.log(JSON.stringify(response))
      setLocation(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event) => {
    setIpAddress(event.target.value);
  };

  const handleFetchClick = () => {
    fetchLocation(ipAddress);
  };

  return (
    <div>
      <h1>IP Address Location Finder</h1>
      <div>
        <input
          type="text"
          value={ipAddress}
          onChange={handleInputChange}
          placeholder="Enter IP address"
        />
        <button onClick={handleFetchClick}>Fetch Location</button>
      </div>
      {loading && <p>Loading location...</p>}
      {error && <p>Error fetching location: {error.message}</p>}
      {location && (
        <div>
          <h2>Location Information</h2>
          <pre>{JSON.stringify(location, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default Trucker;
